import { useDialog } from "@fpsoftware/mvp";
import html2canvas from "html2canvas-pro";
import { useState } from "react";
import { BugReportDialog } from "./BugReportDialog";

export const useHelpActions = () => {
  const dialog = useDialog();
  const [capturing, setCapturing] = useState(false);

  const reportBug = async () => {
    setCapturing(true);
    try {
      const canvas = await html2canvas(document.body, {
        useCORS: true,
        logging: false,
      });
      const screenshot = canvas.toDataURL("image/jpeg", 0.7);
      dialog.open(BugReportDialog, { screenshot });
    } finally {
      setCapturing(false);
    }
  };

  return { reportBug, capturing };
};
